/**
 * Product page social sharing feature
 */
const socialSharing = {};

/**
 * Imports
 */
var processInclude = require('base/util');

/**
 * Component configuration constants
 */
const CONFIG = {
    MESSAGE: {
        ERROR: 'Error while using Web share API:',
        NO_SUPPORT: "Browser doesn't support this API !"
    },
    SELECTORS: {
        COMPONENT: '.hom-js-product-share',
        PRODUCT_NAME: '.product-name'
    },
    POST_MESSAGE: {
        action: 'shareProduct',
        title: '',
        URL: ''
    }
};

/**
 * Collection of functions which attach click event listeners
 */
const onClick = {
    share: function () {
        $('body').on('click', CONFIG.SELECTORS.COMPONENT, function () {
            const $productName = $(CONFIG.SELECTORS.PRODUCT_NAME);

            CONFIG.POST_MESSAGE.title = $productName.text();
            CONFIG.POST_MESSAGE.URL = window.location.href;

            window.ReactNativeWebView.postMessage(JSON.stringify(CONFIG.POST_MESSAGE));
        });
    }
};

/**
 * Exposed event listener functions
 */
socialSharing.setEvents = function () {
    processInclude(onClick);
};

module.exports = socialSharing;
